import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const WhatsappButton = () => {
  const phoneNumber = "595973105428";
  const message = encodeURIComponent("¡Hola! Estoy interesado en sus sistemas. ¿Podríamos conversar?");

  return (
    <div className="whatsapp-container">
      <a
        href={`https://wa.me/${phoneNumber}?text=${message}`}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
        <span className="whatsapp-tooltip">¡Contáctenos!</span>
      </a>
    </div>
  );
};

export default WhatsappButton;
